import React, { useState, memo, useEffect } from "react";

import { useDispatch } from "react-redux";

import { useReduxSelector } from "@hooks/useReduxSelector";
import { reimbursmentAction } from "@store/actions";

import BaseContent from "@pages/layouts/container/BaseContent";
import { permissionEmployeeTabs } from "@pages/layouts/utils/Permissions.lists";

import ContainerDesktop from "./Desktop/index";
import MobileContent from "./Mobile/index";
import { ExpensesContext } from "./context";

const Index = memo(function Index() {
  const availableTabs = permissionEmployeeTabs["expensesNotes"];
  const [activeTab, setActiveTab] = useState("DExpensesNotes");
  const dispatch = useDispatch();
  const { employerLists: _reimbursmentsLists } = useReduxSelector(
    ({ reimbursments }) => reimbursments,
  );

  useEffect(() => {
    async function fetchData() {
      if (!_reimbursmentsLists?.isLoaded) {
        await dispatch(reimbursmentAction.getByEmployer);
      }
    }
    fetchData();
  }, [dispatch, _reimbursmentsLists]);

  return (
    <BaseContent
      availableTabs={availableTabs}
      setActiveTab={setActiveTab}
      activeTab={activeTab}
      classColorSelection="arh-tab-green"
      withTab={true}
    >
      <ExpensesContext.Provider value={_reimbursmentsLists}>
        <div className="arh-flex arh-min-h-[80vh] arh-flex-col arh-space-y-8 arh-bg-white arh-p-4 arh-px-9 arh-pt-4 mobile-768:arh-hidden">
          <ContainerDesktop />
        </div>
        <div className="arh-hidden arh-px-2 mobile-768:arh-block">
          <MobileContent />
        </div>
      </ExpensesContext.Provider>
    </BaseContent>
  );
});
export default Index;
